export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#0A4970',
    light: '#F7F8F8',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: 'rgba(255, 255, 255, 0.2)',
    contrastText: '#22211F',
  },
  text: {
    brand: '#035585',
    primary: '#25272C',
    secondary: '#3E444E',
    tertiaryLight: '#49515B',
    tertiary: '#0F0F0F',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    contrastText: '#22211F',
    onDarkSecondary: 'rgba(255, 255, 255, 0.88)',
    onDarkTertiary: 'rgba(255, 255, 255, 0.75)',
    onDarkEmphasis: 'rgba(255, 255, 255, 0.92)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#003964',
    fill: '#FAFAFA',
    hero1: '#002015B2',
    /** Hero section tint / fade base (Figma #F0F9FF) */
    hero: '#F0F9FF',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#0A4970',
    level2: '#f7f8fb',
    level1: 'rgba(255, 255, 255, 0.12)',
    tableHead: '#006AA7',
    tableSubhead: '#F0F9FF',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDEDED',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#2563BA',
    ribbon: '#BBE6FE',
    offer: '#D7FFF7',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
    dark:'#0B4E8F',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    /** Pricing & benefits — dark concentrated ~top-left 25%, then lighter to bottom-right */
    pricing:'#0A4970',
    learnMore: '#F4F4F4',
    header: '#FAFAFA',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
